/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanUtilizationFilters {
    getFixupPrototypeFunction() { return SavingsPlanUtilizationFilters.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanUtilizationFilters>): SavingsPlanUtilizationFilters {
        let obj = Object.assign(new SavingsPlanUtilizationFilters(), model);
        SavingsPlanUtilizationFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanUtilizationFilters>): SavingsPlanUtilizationFilters {
        if (!model) return null;
        return SavingsPlanUtilizationFilters.newInstance(<SavingsPlanUtilizationFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanUtilizationFilters) {
        if (!obj) return;

        models.SavingsPlanUtilizationFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanUtilizationFilters): boolean {
        Object.setPrototypeOf(obj, SavingsPlanUtilizationFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Plan ID of the purchased savings plan
     */
    plan_id: string;

    /**
     * Service account IDs to filter
     */
    service_account_ids: Array<string>;

    /**
     * Filter metrics on or after this date
     */
    start_date: Date;

    /**
     * Filter metrics on or before this date
     */
    end_date: Date;

}
